import React from 'react';
import { PropTypes } from 'prop-types';
import { useDispatch } from 'react-redux';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import { redirectToVulnDetail } from 'store/Manage/actions';
import Text from './styled';

const LinkedVulns = ({ rowInfo, showSkeleton }) => {
  const vulns = get(rowInfo, 'original.value.vulnerabilities', []);
  const isVulnsCount = typeof vulns === 'number';
  const text = (isVulnsCount || vulns?.length > 1) ? `(${isVulnsCount ? vulns : vulns.length})` : get(vulns, '[0].name', '');
  const vulnId = get(vulns, '[0].id', '');
  const dispatch = useDispatch();

  const goToVulns = () => {
    if (vulns?.length === 1) dispatch(redirectToVulnDetail(vulnId));
  };

  if (showSkeleton) return <Skeleton />;
  return (
    <Text children={ text } onClick={ goToVulns } canRedirect={ vulns?.length === 1 } />
  );
};

LinkedVulns.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  showSkeleton: PropTypes.bool
};

LinkedVulns.defaultProps = {
  showSkeleton: false
};

export default LinkedVulns;
